
import jquery from "jquery";
window.$ = window.jQuery = jquery;


const selectors = {
  nav: '.product__sticky-wrapper',
  productMeta: '[data-section-type="product"]',
  payment_container : '.buy_btn_not_stick'
}

const classes = {
  sticky: 'is-sticky'
}

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

var mWidth = window.innerWidth;
function handleScroll(navElement){
  const productMetaHeight = $(selectors.productMeta).height() + 100;

  if (mWidth >750) {

if( $(window).scrollTop() > productMetaHeight && !(navElement.hasClass(classes.sticky))){
    navElement.addClass(classes.sticky);
   

  } else if ($(window).scrollTop() <= productMetaHeight){
    navElement.removeClass(classes.sticky);
 
  }
}
else{


}
}

document.addEventListener("DOMContentLoaded", function () {
  const $stickyNav = $(selectors.nav);
  if (!!$stickyNav.length) {
    
    $(window).on('scroll', function () {
      debounce(handleScroll($stickyNav), 100, true)
    });

  
  }


});


